module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCool@2x.ff6f947.jpg";